import { useEffect, useState } from "react";
import api from "../lib/api";
import { ClipboardText } from "@phosphor-icons/react";

export const AiSubmissionLog = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/ai-transparency/submissions").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  if (items === null) return null;

  return (
    <div className="border border-border bg-card p-5" data-testid="ai-submission-log">
      <div className="flex items-start gap-3 mb-1">
        <ClipboardText size={20} className="mt-0.5 text-primary shrink-0" />
        <div>
          <h3 className="font-semibold">AI Submission Log</h3>
          <p className="text-xs text-muted-foreground">
            Fingerprint of every payload sent to AI from this entity — who sent it, feature, size,
            SHA-256 hash and a short preview. Full text is deliberately not stored. Most recent 200 shown.
          </p>
        </div>
      </div>
      {items.length === 0 ? (
        <p className="text-xs text-muted-foreground mt-3">No AI submissions logged yet.</p>
      ) : (
        <div className="mt-3 max-h-96 overflow-auto">
          <table className="w-full text-xs" data-testid="ai-submission-table">
            <thead className="bg-secondary sticky top-0">
              <tr>
                {["When", "User", "Feature", "Class", "Confirmed", "Chars", "SHA-256", "Preview"].map((h) => (
                  <th key={h} className="text-left px-2 py-1.5 font-semibold whitespace-nowrap">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.id} className="border-t border-border align-top">
                  <td className="px-2 py-1.5 whitespace-nowrap font-mono">{(r.ts || "").slice(0, 19).replace("T", " ")}</td>
                  <td className="px-2 py-1.5 whitespace-nowrap">{r.user_name || r.user_email || "—"}</td>
                  <td className="px-2 py-1.5 whitespace-nowrap font-mono">{r.feature}</td>
                  <td className="px-2 py-1.5">
                    {r.data_class === "confidential" ? (
                      <span className="text-[10px] uppercase tracking-wider text-amber-800 bg-amber-50 border border-amber-300 px-1.5 py-0.5">Confidential</span>
                    ) : (
                      <span className="text-[10px] uppercase tracking-wider text-emerald-700 bg-emerald-50 border border-emerald-200 px-1.5 py-0.5">Public</span>
                    )}
                  </td>
                  <td className="px-2 py-1.5">{r.confirmed ? "Yes" : "—"}</td>
                  <td className="px-2 py-1.5 text-right font-mono">{(r.chars || 0).toLocaleString()}</td>
                  <td className="px-2 py-1.5 font-mono" title={r.sha256}>{(r.sha256 || "").slice(0, 12)}…</td>
                  <td className="px-2 py-1.5 text-muted-foreground max-w-[22rem] truncate" title={r.preview}>{r.preview}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AiSubmissionLog;
